import { createContext, useContext } from "react";

import type { ColorPickerContextValue } from "./ColorPicker.types";
import { DEFAULT_COLOR } from "./constants";

export function makeColorPickerContext({
  size = "md",
  disabled = false,
  arrow = true,
  hex = DEFAULT_COLOR,
  hsv = { h: 0, s: 0, v: 0 },
  pointerOffsetRef = { current: 0 },
  setHsv = () => {},
  setHex = () => {},
}: Partial<ColorPickerContextValue>): Required<ColorPickerContextValue> {
  return {
    size,
    disabled,
    arrow,
    hex,
    hsv,
    pointerOffsetRef,
    setHsv,
    setHex,
  };
}

export const ColorPickerContext = createContext<
  Required<ColorPickerContextValue>
>(makeColorPickerContext({}));

export function useColorPickerContext() {
  return useContext(ColorPickerContext);
}
